/* RESPONSIBLE TEAM: team-inbox */
import Helper from '@ember/component/helper';

export default class InboxCapacityHelper extends Helper {
  compute([inbox, workspaceCapacity]) {
    if (inbox.admin.workload_management_settings?.assignment_limit) {
      return inbox.admin.workload_management_settings.assignment_limit;
    } else {
      return workspaceCapacity;
    }
  }
}
